/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-11-06 18:10:02
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-25 16:24:25
 * @FilePath: \mpc-monorepo\features\mpc-common\src\features\MPCDemand\KOLInquiryForQuotation\SupplierKOLTable\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { forwardRef, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { SupplierDesignatedKOLTable } from './SupplierDesignatedKOLTable';
import { SupplierDemandSourceMatchTables } from './SupplierDemandSourceMatchTables';
import { DemandSourceSupplierKolVo } from '#services/api';
import { useMemoizedFn } from 'ahooks';

type SupplierKOLTableProps = {
  detailData?: any;
  value?: DemandSourceSupplierKolVo[];
  onChange?: (value: DemandSourceSupplierKolVo[]) => void;
  view?: boolean;
  // 批量导入方法
  handleBatchSubmission?: () => void;
}
export const SupplierKOLTable = React.forwardRef<any, SupplierKOLTableProps>((props, ref) => {
  const { detailData, value, onChange, view = false, handleBatchSubmission } = props;

  
  const designatedKOLRef = useRef<any>(null);
  const customInspectionRef = useRef<any>(null);

  useImperativeHandle(ref, () => ({
    // 验证指定达人数据
    validateFields: () => {
      // 至少提报一项提报达人数据
      // if (value?.length === 0) {
      //   Message.warn('请至少提报1个达人');
      //   return Promise.reject('');
      // }
      return Promise.all([
        designatedKOLRef.current?.validateFields?.(),
        customInspectionRef.current?.validateFields?.(),
      ]).then((res) => {
        return res;
      }).catch((err) => {
        console.log('validateFieldsError', err);
        return Promise.reject('');
      })  as Promise<any>;
    },
  }));

  // 指定达人数据，和变更
  const designatedKOLData = useMemo(() => {
    return value?.filter((item) => item.by_plan) || [];
  }, [value]);

  // 定制排查数据，和变更
  const customInspectionData = useMemo(() => {
    return value?.filter((item) => !item.by_plan) || [];
  }, [value]);
  const designatedKOLOnChange = useMemoizedFn((value: DemandSourceSupplierKolVo[]) => {
    onChange?.([...value, ...customInspectionData]);
  });

  const customInspectionOnChange = useMemoizedFn((value: DemandSourceSupplierKolVo[]) => {
    onChange?.([...designatedKOLData, ...value]);
  });
  return (
    <div className='flex-1 w-[500px]'>
      {detailData?.demand_source_detail_vo?.demand_source_kol_vo?.length > 0 && <SupplierDesignatedKOLTable
        detailData={detailData}
        value={designatedKOLData}
        onChange={designatedKOLOnChange}
        ref={designatedKOLRef}
        view={view}
      />}
      <SupplierDemandSourceMatchTables
        detailData={detailData}
        value={customInspectionData}
        onChange={customInspectionOnChange}
        ref={customInspectionRef}
        view={view}
        tabsModel={false}
        handleBatchSubmission={handleBatchSubmission}
      />
    </div>
  );
});

SupplierKOLTable.displayName = 'SupplierKOLTable';